import React from 'react';

// Inline SVG to avoid extra HTTP request and enable faster rendering
const PhoneIcon = React.memo(props => (
  <svg {...props} width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <g clipPath="url(#phoneIconClip)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.32399 17.9098C4.784 19.3695 7.00205 19.1428 8.78332 18.4984C10.6892 17.8089 12.7556 16.4382 14.5982 14.596C16.4409 12.7538 17.8111 10.6887 18.4997 8.78381C19.1436 7.00278 19.3681 4.78672 17.9086 3.32755L16.2386 1.65796C15.3612 0.780681 13.9381 0.780681 13.0606 1.65796L11.3568 3.36137C10.4791 4.23883 10.4791 5.66217 11.3568 6.53964L12.4474 7.63C12.4565 7.70274 12.4585 7.90283 12.3167 8.30602C12.0821 8.97275 11.5481 9.83582 10.7142 10.6695C9.88017 11.5034 9.00337 12.0507 8.31958 12.2962C7.90595 12.4446 7.6995 12.4456 7.62366 12.4376L6.54007 11.3543C5.66259 10.477 4.23952 10.477 3.36204 11.3543L1.65824 13.0577C0.781082 13.9347 0.780573 15.3569 1.65671 16.2344C1.65722 16.235 1.65773 16.2355 1.65824 16.236L3.32399 17.9098ZM13.5377 13.5352C10.0921 16.98 5.99532 18.4594 4.38453 16.849L2.71878 15.1752C2.42706 14.8835 2.42706 14.4101 2.71878 14.1185L4.42258 12.4151C4.7143 12.1234 5.18781 12.1234 5.47953 12.4151L6.64217 13.5775C7.53847 14.4735 9.85953 13.6451 11.7747 11.7303C13.6899 9.81558 14.4763 7.53732 13.58 6.64123L12.4173 5.47886C12.1256 5.1872 12.1256 4.7138 12.4173 4.42215L14.1211 2.71874C14.4129 2.42709 14.8864 2.42709 15.1781 2.71874L16.8481 4.38833C18.4589 5.99875 16.9834 10.0903 13.5377 13.5352Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="phoneIconClip">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
));

PhoneIcon.displayName = 'PhoneIcon';

export default PhoneIcon;
